import styled from 'styled-components';

interface ScCounterProps {
  mainRadialGradient: string;
  spinBtnBg?: string;
}

export const ScCounter = styled.div<ScCounterProps>`
  margin-top: 2rem;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.01em;
  text-align: center;
  color: white;
  padding: 12px 32px;
  background: ${({ mainRadialGradient, spinBtnBg }) =>
    spinBtnBg ? spinBtnBg : mainRadialGradient};
  position: relative;
  z-index: 10000;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 360px;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50px;
    border: 5px solid transparent;
    background: linear-gradient(
        103.12deg,
        #bd5d0d 5.72%,
        #ffec93 48.88%,
        #bd5d0d 92.05%
      )
      border-box;
    mask:
      linear-gradient(#fff 0 0) padding-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }
`;
